import axios from 'axios';

export const obtenerNivelUsuario = (estado, distrito, rolUsuario, userRol) => {
    let nivelU = '';
    let nivel = rolUsuario.split('.')[2].split('_');

    if (nivel.length === 2) {
        nivelU =  `${nivel[1]} ${distrito} ${estado}`;
    }else{
        switch (userRol) {
            case 'JL':
                nivelU = `${userRol} ${estado}`;
                break;
            case 'JD':
                nivelU = `${userRol} ${estado} ${distrito}`;
                break;
            case 'OC':
                nivelU = 'DECEyEC';
                break;
            default:
                nivelU = '';
        }
    }
    
    return nivelU;
}

	/**
	* Obtiene el estado y distrito del aspirante logeado.
	**/
export const obtenerEdoDtoAspirante = (parametros) => {
    return new Promise((resolver, rechazar) => {
        axios.post(process.env.REACT_APP_API_URL +
            "/ws_reclutaseycae_central/ws/obtenerEstadoDistrito",
            parametros,
            {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json', 
                    'Authorization': localStorage.getItem("jwt-token") 
                }
            }).then(res => {
                resolver(res.data);
            }).catch(_error => {
                rechazar()
            });
    });
}